import React from 'react'
import {Form, Label, Header, Segment, Grid, GridColumn, GridRow, Container } from 'semantic-ui-react'
import Timer from './Timer'
import { connect } from 'react-redux'
import soundForVote from '../assets/000001.mp3'
import Range from './Range'

const myPath = '../assets/';
//const myPath = 'http://s3.amazonaws.com/cicciolanciabucket/assets/';


const createDiceUrl = (number) => (
    myPath+""+number+".png"
 )
 
class FormChoice extends React.Component {
   
    minChoice = 1

    constructor(props) {
        super(props)
        this.state = {
            starting_time: null,
            msToAnswer: props.msToAnswer,
            jump:props.jump,
            isRunning:true,
            hasChoiced:false,
            currentChoice: 1,
        }
    }

    componentDidMount() {
        this.setState({ starting_time: Date.now() })
    }
    
    onTimerFinished = () => {
        this.setState({isRunning:false});
        this.props.handleChoice(this.state.currentChoice);
    }

    handleAnswer = (result) =>{
    }

    onSubmit = (e) => {
        e.preventDefault()
        const choice = this.adjustBet(this.state.currentChoice)
        this.choiced(choice)
        return false
    }

    choiced = (choice) =>{
        this.setState({isRunning:false, hasChoiced:true, currentChoice:choice});
        this.props.handleChoice(choice);
    }

    onRangeChange = (value) => this.setState({ currentChoice: this.adjustBet(Math.round(value)) })

    adjustBet = (value) => {
        return Math.max(this.minChoice, Math.min(value, 20));
    }

  
    render() {
        const {msToAnswer, hasChoiced, currentChoice }= this.state

        return (
            <Form onSubmit={this.onSubmit}  style={{ textAlign: 'left' }}>
                <Segment style={{ maxWidth: '800px', margin: 'auto' }}>
                    <Label color='purple' ribbon>{"Scelta"}</Label>
                    <div style={{ textAlign: 'center' }}>
                        <Header as='h2' style={{ fontWeight: 'normal' }}>'SCEGLI IL RISULTATO!'</Header>
                        {hasChoiced?<audio ref="audio_tag" src={soundForVote} autoPlay/>:""}
                        <Grid centered celled>
                            <GridRow >
                               <GridColumn>
                               <Container textAlign='center'>
                                    <Grid centered celled>
                                    <GridRow >
                                    <GridColumn>
                                    <Container textAlign='center'>
                                    <img src={createDiceUrl(currentChoice)} width="200"/>
                                    </Container>
                                    </GridColumn>
                                    </GridRow >
                                    {hasChoiced?"":
                                    <GridRow >
                                    <GridColumn>
                                    <Container textAlign='center'>
                                    <Range maxValue={20} value={currentChoice} onChange={this.onRangeChange} />
                                    </Container>
                                    </GridColumn>
                                    </GridRow >
                                        }
                                    <GridRow >
                                    <GridColumn>
                                    <Container textAlign='center'>
                                    {hasChoiced?<Label size='big' color='red'>SCELTO!</Label>:<Form.Button primary fluid type="submit">Scelto</Form.Button>}
                                    </Container>
                                    </GridColumn>
                                    </GridRow >
                                    </Grid>
                               </Container>
                               </GridColumn>
                            </GridRow>
                        </Grid>
                        <Timer  ms={msToAnswer} isReady={true} bar={false} isRunning={this.state.isRunning} handleAnswer={this.props.handleAnswer} onTimerFinished ={this.onTimerFinished}  />
                    </div>
                    <Timer  ms={msToAnswer} isReady={true} isRunning={this.state.isRunning} bar={true}  handleAnswer={this.props.handleAnswer} onTimerFinished ={this.onTimerFinished} />
                </Segment>
            </Form>

        )
    }

}



const mapStateToProps = (state, { isLogged }) => ({
    state : state, 
    user: state.user,
    isLogged,
})

const mapDispatchToProps = (dispatch, { socket }) => ({

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FormChoice)


// WEBPACK FOOTER //
// ./src/components/FormChoice.js